/**
 * HealthTicker.jsx
 *
 * Thin React wrapper that reuses the exact Priority Dashboard health ticker
 * implementation (health-ticker.css & healthTickerCore.js).
 */
import React, { useEffect, useRef } from 'react';
import './health-ticker.css';
import { initHealthTicker } from './healthTickerCore';

const HealthTicker = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    let cleanup = null;
    if (mountRef.current) {
      cleanup = initHealthTicker(mountRef.current);
    }
    return () => {
      if (typeof cleanup === 'function') {
        cleanup();
      }
    };
  }, []);

  return <div id="hs-ticker-mount" ref={mountRef} className="hs-ticker-mount" />;
};

export default HealthTicker;
